module.exports = __webpack_public_path__ + "img/manage-active.dffafa37.svg";